"use client";
import SoftwareSorting from "@casino/external/icons/SoftwareSorting";
import { Button } from "@workspace/frontend-ui";
import { useState } from "react";

type Props = {
  title: string;
  subtitle: string;
  casinoBoostSettings?: string;
  handle?: string;
};

const MobileFirstRow: FC<Props> = ({
  children,
  title,
  subtitle,
  casinoBoostSettings,
  handle,
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const handleFilterClick = () => setShowFilters((isVisible) => !isVisible);
  const hideSorting = handle === "favourite" || handle === "recents";
  return (
    <div className="relative grid grid-cols-minmax gap-4 md:mb-2.5 lg:grid-flow-col lg:justify-between">
      <div className="grid grid-flow-col grid-cols-minmax gap-2 p-1">
        <div className="grid grid-cols-minmax gap-1">
          <h1 className="z-2 self-end text-2xl text-foreground">{title}</h1>
          {subtitle && (
            <p className="text-sm/6 text-muted-foreground sm:text-base">
              {subtitle}
            </p>
          )}
        </div>
        {(!casinoBoostSettings || hideSorting) && (
          <Button
            type="button"
            data-testid="filter-button"
            variant="secondary"
            size="icon"
            aria-label="Filters"
            onClick={handleFilterClick}
            className="size-10 rounded"
          >
            <SoftwareSorting className="size-8" />
          </Button>
        )}
      </div>
      {showFilters && children}
    </div>
  );
};

export default MobileFirstRow;
